import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

import { useCanSeeTmBackedComplianceScreen } from "./-components/is-compliance-enabled";
import { TransactionMonitoringCaseListRoute } from "../_transaction-monitoring/-components/transaction-monitoring-list-route";

export const Route = createFileRoute(
  "/(app)/_main-layout/_compliance/compliance/with-volume",
)({
  component: ComplianceWithVolumeRoute,
});

function ComplianceWithVolumeRoute() {
  const tmBackedCompliance = useCanSeeTmBackedComplianceScreen();
  const navigate = useNavigate();
  useEffect(() => {
    if (!tmBackedCompliance) {
      void navigate({ to: "/compliance", replace: true });
    }
  }, [navigate, tmBackedCompliance]);
  return tmBackedCompliance ? (
    <TransactionMonitoringCaseListRoute statusFilter="with_volume" />
  ) : null;
}
